export const report = {
	es: {
		texts: [
			"Reporte",
			"Reportes",
			"Indicadores",
			"Exportar datos",
			"Selecciona las opciones que deseas exportar",
			"Sin datos",
			"Para visualizar tus datos primero realiza una consulta desde el menú lateral",
			"En Proceso",
			"Consultando el kilometraje",
		],
		tabs: {
			global: "Reporte Gráfico",
			ind: "Individual",
			details: "Detalles",
			temperature: "Temperatura",
			trips: "Trayectos",
			drivers: "Conductores",
			status_report: "Reporte de estatus",
		},
		actions: {
			filter: "Buscar un vehículo",
			group: "Buscar un grupo",
			search: "Buscar",
			consult: "Consultar",
			all: "Seleccionar todos",
			pdf: "Exportar PDF",
			excel: "Exportar Excel",
			print: "Imprimir",
			dates: "Seleccionar días",
			devices: "Seleccionar dispositivo",
			scale: "Seleccionar escala",
			scales: ["Fahrenheit", "Centígrados"],
			detailScales: ["Fahrenheit", "Centígrados"],
		},
		modals: {
			//
		},
		measurements: {
			hours: "hrs",
			distance: "km",
			speed: "km/hrs",
			days: "Sin días | día | días",
		},
		alerts: {
			"001": {
				label: "Ayuda/Pánico",
				visible: true,
			},
			"002": {
				label: "Motor Encendido",
				visible: true,
			},
			"003": {
				label: "Motor Apagado",
				visible: true,
			},
			"004": {
				label: "Puerta Abierta",
				visible: true,
			},
			"005": {
				label: "Puerta Cerrada",
				visible: true,
			},
			"006": {
				label: "Desconexión de GPS",
				visible: true,
			},
			"007": {
				label: "Batería Baja",
				visible: true,
			},
			"012": {
				label: "Paro de Motor Encendido",
				visible: true,
			},
			"013": {
				label: "Paro de Motor Apagado",
				visible: true,
			},
			"014": {
				label: "Error en Motor",
				visible: true,
			},
			"019": {
				label: "Barredora Encendida",
				visible: true,
			},
			"020": {
				label: "Barredora Apagada",
				visible: true,
			},
			"021": {
				label: "Grúa Encendida",
				visible: true,
			},
			"025": {
				label: "Inactividad",
				visible: true,
			},
			"026": {
				label: "RPM",
				visible: true,
			},
			"027": {
				label: "Aceleración",
				visible: true,
			},
			"028": {
				label: "Desaceleración",
				visible: true,
			},
			"030": {
				label: "Parada",
				visible: true,
			},
			"030Y": {
				label: "Parada Mínima",
				visible: true,
			},
			"030G": {
				label: "Parada Media",
				visible: true,
			},
			"030R": {
				label: "Parada Máxima",
				visible: true,
			},
			"032": {
				label: "Exceso de Velocidad",
				visible: true,
			},
			"033": {
				label: "Límite de velocidad",
				visible: true,
			},
			"035": {
				label: "Entrada a Geocerca",
				visible: true,
			},
			"036": {
				label: "Salida a Geocerca",
				visible: true,
			},
			"037": {
				label: "Geocerca Tiempo Mínimo",
				visible: true,
			},
			"038": {
				label: "Geocerca Tiempo Máximo",
				visible: true,
			},
			"040": {
				label: "Cambio de Turno",
				visible: true,
			},
			"041": {
				label: "Caja Conectada",
				visible: true,
			},
			"042": {
				label: "Caja Desconectada",
				visible: true,
			},
			"050": {
				label: "WIFI",
				visible: true,
			},
			"051": {
				label: "GPRS",
				visible: true,
			},
			"053": {
				label: "Aplicación Cerrada",
				visible: true,
			},
			992: {
				label: "Señal recuperada",
				visible: true,
			},
			994: {
				label: "Modo Sueño",
				visible: true,
			},
			996: {
				label: "Memoria Perdida",
				visible: true,
			},
			997: {
				label: "Error Paro de Motor",
				visible: true,
			},
			998: {
				label: "Reinicio de GPS",
				visible: true,
			},
			999: {
				label: "Perdida de Señal",
				visible: true,
			},
		},
		allowed: {
			times: ["002", "003", "030G", "030Y", "030R"],
			details: [
				"002",
				"006",
				"004",
				"001",
				"007",
				"030",
				"032",
				"033",
				"035",
				"025",
				"026",
				"027",
				"019",
				"021",
				"090",
				"091",
				"092",
				"015",
				"016",
				"070",
				"071",
				"200",
				"201",
				"300",
				"400",
			],
		},
		global: {
			alerts: {
				title: "Alertas",
				help: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec vitae pretium tortor. Mauris rhoncus orci et GS Trackme. Proin ullamcorper sagittis libero, vel pulvinar dui tristique ac. Maecenas eleifend ornare ante, pretium bibendum lorem facilisis imperdiet. Cras id tortor vitae ex vulputate volutpat a vitae mi.",
			},
			time: {
				title: "Tiempo",
				help: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec vitae pretium tortor. Mauris rhoncus orci et GS Trackme. Proin ullamcorper sagittis libero, vel pulvinar dui tristique ac. Maecenas eleifend ornare ante, pretium bibendum lorem facilisis imperdiet. Cras id tortor vitae ex vulputate volutpat a vitae mi.",
			},
			distance: {
				title: "Distancia recorrida",
				help: "Cuántos kilometros fueron conducidas en total; y el promedio de kilometros por vehículo.",
				total: "Total",
				average: "Promedio",
			},
			idle: {
				total: {
					title: "Total de inactividad diaria",
					help: "Cuánto tiempo pasaron en inactividad todos los vehículos combinados.",
				},
				ind: {
					title: "Inactividad por dispositivo",
					help: "Cuánto tiempo estuvo inactivo cada dispositivo por día.",
				},
				excess: {
					title: "Inactividad excedida",
					help: "Cuánto tiempo se pasó inactivo por encima del límite diario asignado. El límite diario se puede establecer yendo a <b>ADMINISTRADOR</b> y luego haciendo clic en <b>DISPOSITIVOS</b>, desde allí puede hacer clic en el botón Editar (lápiz) para cada dispositivo.",
					total: "Total",
					excess: "Excedida",
					allowed: "Permitido",
					csv: [
						"Dispositivo",
						"Días con actividad",
						"Tiempo de inactividad total",
						"Inactividad promedio por parada",
						"Duración promedio de inactividad",
						"Inactividad más larga",
						"Permitido",
						"Tiempo excedido",
						"Horas encendido",
					],
				},
			},
			fuel: {
				title: "Consumo de gasolina",
				help: "",
				level: "Nivel",
				decrement: "Decremento",
				increment: "Incremento",
			},
			chart: {
				contextButtonTitle: "Opciones de descarga",
				downloadJPEG: "Descargar JPEG",
				downloadPDF: "Descargar PDF",
				downloadPNG: "Descargar PNG",
				downloadSVG: "Descargar vector SVG",
				printChart: "Imprimir gráfico",
			},
			temperature: {
				title: "Detalle de temperatura",
				help: "",
				degrees: "Grados",
				decrement: "Decremento",
				increment: "Incremento",
				noTrackings: "No hay registros para mostrar",
				info: {
					average:
						"Muestra la temperatura promedio en un periodo de tiempo",
					detail: "Muestra las mediciones de temperatura en un periodo de tiempo",
				},
			},
		},
		individual: {
			time: "Tiempo",
			distance: "Distancia",
		},
		details: {
			headers: {
				devices: {
					label: "Dispositivo",
					icon: false,
				},
				date: {
					label: "Fecha",
					icon: false,
				},
				distance: {
					label: "KM",
					icon: false,
				},
				totalengine: {
					label: "Encendido",
					icon: false,
				},
			},
			subheaders: {
				action: {
					label: "Acción",
					width: "",
				},
				address: {
					label: "Dirección",
					width: "20%",
				},
				alarm: {
					label: "Alarma",
					width: "8%",
				},
				coords: {
					label: "Coordenadas",
					width: "12%",
				},
				comment: {
					label: "Comentario",
					width: "",
				},
				endtime: {
					label: "Fin Tiempo",
					width: "10%",
				},
				engineoff: {
					label: "Apagado",
					width: "10%",
				},
				engineon: {
					label: "Encendido",
					width: "10%",
				},
				event: {
					label: "Evento",
					width: "8%",
				},
				geofence: {
					label: "Geocerca",
					width: "16%",
				},
				hour: {
					label: "Hora",
					width: "11%",
				},
				idle: {
					label: "Tiempo Inactividad",
					width: "10%",
				},
				lat: {
					label: "Latitud",
					width: "",
				},
				long: {
					label: "Longitud",
					width: "",
				},
				mileage: {
					label: "Kilometraje",
					width: "8%",
				},
				name: {
					label: "Nombre",
					width: "",
				},
				speed: {
					label: "Velocidad",
					width: "8%",
				},
				starttime: {
					label: "Inicio Tiempo",
					width: "10%",
				},
				state: {
					label: "Estado",
					width: "",
				},
				stoptime: {
					label: "Tiempo Detenido",
					width: "10%",
				},
				time: {
					label: "Tiempo",
					width: "8%",
				},
				roadtype: {
					label: "Tipo de carretera",
					width: "12%",
				},
				postedspeed: {
					label: "Limite de velocidad",
					width: "12%",
				},
				diff: {
					label: "Diferencia",
					width: "10%",
				},
				entry: {
					label: "Entrada",
					width: "15%",
				},
				output: {
					label: "Salida",
					width: "15%",
				},
				device: {
					label: "Dispositivo",
					width: "",
				},
				datetime: {
					label: "Fecha",
					width: "12%",
				},
				battery: {
					label: "Bateria",
					width: "8%",
				},
				sensor: {
					label: "Sensor",
					width: "8%",
				},
				level: {
					label: "Nivel",
					width: "8%",
				},
				min: {
					label: "Mínimo",
					width: "8%",
				},
				max: {
					label: "Máximo",
					width: "8%",
				},
				degrees: {
					label: "Grados",
					width: "8%",
				},
				signaloff: {
					label: "Perdida de señal",
					width: "10%",
				},
				signalon: {
					label: "Señal recuperada",
					width: "10%",
				},
			},
			roads:{
				bridleway: "Carretera de herradura",
				bus_guideway: "Guía de autobús",
				busway: "Vía de autobús",
				construction: "Construcción",
				crossing: "Cruce",
				cycleway: "Carríl de bicicleta",
				footway: "Vía peatonal",
				living_street: "Calle viva",
				motorway: "Autopista",
				motorway_link: "Enlace de autopista",
				path: "Ruta",
				pedestrian: "Peatonal",
				primary: "Calle principal",
				primary_link: "Enlace principal",
				proposed: "Propuesta",
				raceway: "Autopista",
				residential: "Residencial",
				road: "Carretera",
				secondary: "Calle secundaria",
				secondary_link: "Enlace secundario",
				service: "Servicio",
				steps: "Pasos",
				tertiary: "Calle terciaria",
				tertiary_link: "Enlace terciario",
				track: "Pista",
				trunk: "Entronque",
				trunk_link: "Entronque",
				turning_circle: "Glorieta",
				unclassified: "Sin clasificar",
			}
				
		},
		temperature: {
			global: "Temperatura promedio",
			average: "Promedio",
			help: "Seleccione una columna para ver los detalles",
		},
		trips: {
			columns: [
				{
					title: "Conductor",
					visible: true,
				},
				{
					title: "Dispositivo",
					visible: true,
				},
				{
					title: "Fecha inicial",
					visible: true,
				},
				{
					title: "Fecha final",
					visible: true,
				},
				{
					title: "Duración",
					visible: true,
				},
				{
					title: "Coordenadas iniciales",
					visible: true,
				},
				{
					title: "Coordenadas finales",
					visible: true,
				},
				{
					title: "Dirección inicial",
					visible: true,
				},
				{
					title: "Dirección final",
					visible: true,
				},
			],
			details: {
				columns: ["Datos iniciales", "Datos finales"],
				rows: ["Fecha", "Coordenadas", "Dirección"],
			},
		},
		notifications: {
			query: {
				nodata: "No hay datos para la consulta",
				error: "Error de consulta",
				noparams:
					"Debe seleccionar al menos un dispositivo y el rango de fechas",
			},
			timezone: {
				info: "Estimados usuarios de GS Trackme México: con el cambio de hora después del horario de verano. Estamos experimentando una discrepancia de una hora si ejecuta un reporte para fechas anteriores al 25 de octubre. Estamos trabajando activamente para ajustar esto. Gracias por su paciencia.",
			},
		},
		status_report: {
			labels: [
				"Reporte de dispositivos por estatus",
				"Este reporte es la información actual",
				"Refrescar información",
				"Filtrar por nombre, imei o teléfono",
				"No hay información",
				"Estatus",
				"Descargar archivo excel",
				"Reporte de estatus",
			],
			table_head: [
				"Nombre",
				"Imei",
				"Teléfono",
				"Estatus",
				"Última localización",
				"Último trackeo",
			],
			table_pagination: ["Página", "de", "filas por pagina"],
			code_status: {
				0: "Cancelado",
				1: "Activo",
				3: "Inactivo24",
				7: "Inactivo72",
				20: "Sin gps",
				21: "Sin pusheo",
				22: "Dormido",
				23: "EngineStop",
				24: "Sin batería",
				25: "Suspendido",
			},
		},
	},
	en: {
		texts: [
			"Report",
			"Reports",
			"Indicators",
			"Export data",
			"Select the options you want to export",
			"No data",
			"To view your data, first make a query from the side menu",
			"On Going",
			"Checking the mileage",
		],
		tabs: {
			global: "Graph Report",
			ind: "Individual",
			details: "Details",
			temperature: "Temperature",
			trips: "Journeys",
			drivers: "Drivers",
			status_report: "Status report",
		},
		actions: {
			filter: "Search a vehicle",
			group: "Search a group",
			search: "Start",
			consult: "Consult",
			all: "Select all",
			pdf: "Export PDF",
			excel: "Export Excel",
			print: "Print",
			dates: "Select days",
			devices: "Select device",
			scale: "Select scale",
			scales: ["Fahrenheit", "Celcius"],
			detailScales: ["Fahrenheit", "Celcius"],
		},
		modals: {
			//
		},
		measurements: {
			hours: "hrs",
			distance: "mi",
			speed: "mi / hrs",
			days: "No days | day | days",
		},
		alerts: {
			"001": {
				label: "SOS Button",
				visible: true,
			},
			"002": {
				label: "Engine On",
				visible: true,
			},
			"003": {
				label: "Engine Off",
				visible: true,
			},
			"004": {
				label: "Open Door",
				visible: true,
			},
			"005": {
				label: "Closed Door",
				visible: true,
			},
			"006": {
				label: "GPS Unplugged",
				visible: true,
			},
			"007": {
				label: "Low Battery",
				visible: true,
			},
			"012": {
				label: "Engine Stop On",
				visible: true,
			},
			"013": {
				label: "Engine Stop Off",
				visible: true,
			},
			"014": {
				label: "Motor Error",
				visible: true,
			},
			"019": {
				label: "Sweeper On",
				visible: true,
			},
			"020": {
				label: "Sweeper Off",
				visible: true,
			},
			"021": {
				label: "PTO On",
				visible: true,
			},
			"025": {
				label: "Idle",
				visible: true,
			},
			"026": {
				label: "RPM",
				visible: true,
			},
			"027": {
				label: "Acceleration",
				visible: true,
			},
			"028": {
				label: "Deceleration",
				visible: true,
			},
			"030": {
				label: "Stop",
				visible: true,
			},
			"030Y": {
				label: "Short Stop",
				visible: true,
			},
			"030G": {
				label: "Moderate Stop",
				visible: true,
			},
			"030R": {
				label: "Long Stop",
				visible: true,
			},
			"032": {
				label: "Speeding",
				visible: true,
			},
			"033": {
				label: "Posted Speed",
				visible: true,
			},
			"035": {
				label: "Entrance to Geofence",
				visible: true,
			},
			"036": {
				label: "Exit to Geofence",
				visible: true,
			},
			"037": {
				label: "Geofence Minimum Time",
				visible: true,
			},
			"038": {
				label: "Geofence Maximum Time",
				visible: true,
			},
			"040": {
				label: "Shift Change",
				visible: true,
			},
			"041": {
				label: "Connected Box",
				visible: true,
			},
			"042": {
				label: "Box Disconnected",
				visible: true,
			},
			"050": {
				label: "WIFI",
				visible: true,
			},
			"051": {
				label: "GPRS",
				visible: true,
			},
			"053": {
				label: "Application Closed",
				visible: true,
			},
			992: {
				label: "Signal recovered",
				visible: true,
			},
			994: {
				label: "Sleep Mode",
				visible: true,
			},
			996: {
				label: "Lost Memory",
				visible: true,
			},
			997: {
				label: "Motor Stop Error",
				visible: true,
			},
			998: {
				label: "GPS reset",
				visible: true,
			},
			999: {
				label: "Signal loss",
				visible: true,
			},
		},
		allowed: {
			times: ["002", "003", "030G", "030Y", "030R"],
			details: [
				"002",
				"006",
				"004",
				"001",
				"007",
				"030",
				"032",
				"033",
				"035",
				"025",
				"026",
				"027",
				"019",
				"021",
				"090",
				"091",
				"092",
				"015",
				"016",
				"070",
				"071",
				"200",
				"201",
				"300",
				"400",
			],
		},
		global: {
			alerts: {
				title: "Alerts",
				help: "Lorem ipsum pain sit amet, consectetur adipiscing elit. Donec Vitae Pretium Tortor. Mauris rhoncus orci and GS Trackme. Proin ullamcorper sagittis libero, vel pulvinar dui tristique ac. Maecenas eleifend ornare ante, pretium bibendum lorem facilisis imperdiet. Cras id tortor vitae ex vulputate volutpat a vitae mi. ",
			},
			time: {
				title: "Time",
				help: "Lorem ipsum pain sit amet, consectetur adipiscing elit. Donec Vitae Pretium Tortor. Mauris rhoncus orci and GS Trackme. Proin ullamcorper sagittis libero, vel pulvinar dui tristique ac. Maecenas eleifend ornare ante, pretium bibendum lorem facilisis imperdiet. Cras id tortor vitae ex vulputate volutpat a vitae mi. ",
			},
			distance: {
				title: "Distance traveled",
				help: "How many miles were driven total; and the average miles per vehicle.",
				total: "Total",
				average: "Average",
			},
			idle: {
				total: {
					title: "Total daily idle",
					help: "How much time was spent Idling by all vehicles combined.",
				},
				ind: {
					title: "Idle per device",
					help: "How much time each device was idling per day.",
				},
				excess: {
					title: "Idle exceeded",
					help: "How much time was spent Idling over the allotted daily limit. The daily limit can be set by going into <b>ADMIN</b> then clicking on <b>DEVICES</b>, from there you can click the edit pencil button for each device.",
					total: "Total",
					excess: "Exceeded",
					allowed: "Allowed",
					csv: [
						"Device",
						"Days with Activity",
						"Total Idle Time",
						"Average Idling Per Stop",
						"Average Idle length",
						"Longest Idle",
						"Allowed",
						"Time Exceeded",
						"Engine Hours",
					],
				},
			},
			fuel: {
				title: "Gas consumption",
				help: "",
				level: "Level",
				decrement: "Decrement",
				increment: "Increment",
			},
			chart: {
				contextButtonTitle: "Download options",
				downloadJPEG: "Download JPEG",
				downloadPDF: "Download PDF",
				downloadPNG: "Download PNG",
				downloadSVG: "Download SVG vector",
				printChart: "Print graphic",
			},
			temperature: {
				title: "Temperature detail",
				help: "",
				degrees: "Degrees",
				decrement: "Decrement",
				increment: "Increment",
				noTrackings: "There is no trackings to show",
				info: {
					average:
						"Shows the average temperature over a period of time",
					detail: "Shows temperature measurements over a period of time",
				},
			},
		},
		individual: {
			time: "Time",
			distance: "Distance",
		},
		details: {
			headers: {
				devices: {
					label: "Device",
					icon: false,
				},
				date: {
					label: "Date",
					icon: false,
				},
				distance: {
					label: "Mi",
					icon: false,
				},
				totalengine: {
					label: "Engine",
					icon: false,
				},
			},
			subheaders: {
				action: {
					label: "Action",
					width: "",
				},
				address: {
					label: "Address",
					width: "20%",
				},
				alarm: {
					label: "Alarm",
					width: "8%",
				},
				coords: {
					label: "Coordinates",
					width: "12%",
				},
				comment: {
					label: "Comment",
					width: "",
				},
				endtime: {
					label: "End Time",
					width: "10%",
				},
				engineoff: {
					label: "Off",
					width: "10%",
				},
				engineon: {
					label: "On",
					width: "10%",
				},
				event: {
					label: "Event",
					width: "8%",
				},
				geofence: {
					label: "Geofence",
					width: "16%",
				},
				hour: {
					label: "Hour",
					width: "11%",
				},
				idle: {
					label: "Idle Time",
					width: "10%",
				},
				lat: {
					label: "Latitude",
					width: "",
				},
				long: {
					label: "Longitude",
					width: "",
				},
				mileage: {
					label: "Mileage",
					width: "8%",
				},
				name: {
					label: "Name",
					width: "",
				},
				speed: {
					label: "Speed",
					width: "8%",
				},
				starttime: {
					label: "Start Time",
					width: "10%",
				},
				state: {
					label: "State",
					width: "",
				},
				stoptime: {
					label: "Stopped Time",
					width: "10%",
				},
				time: {
					label: "Time",
					width: "8%",
				},
				postedspeed: {
					label: "Posted Speed",
					width: "12%",
				},
				roadtype: {
					label: "Road Type",
					width: "12%",
				},
				diff: {
					label: "Difference",
					width: "10%",
				},
				entry: {
					label: "Entry",
					width: "15%",
				},
				output: {
					label: "Exit",
					width: "15%",
				},
				device: {
					label: "Device",
					width: "",
				},
				datetime: {
					label: "Date",
					width: "12%",
				},
				battery: {
					label: "Battery",
					width: "8%",
				},
				sensor: {
					label: "Sensor",
					width: "8%",
				},
				level: {
					label: "Level",
					width: "8%",
				},
				min: {
					label: "Minimum",
					width: "8%",
				},
				max: {
					label: "Maximum",
					width: "8%",
				},
				degrees: {
					label: "Degrees",
					width: "8%",
				},
				signaloff: {
					label: "Sginal loss",
					width: "10%",
				},
				signalon: {
					label: "Signal recovered",
					width: "10%",
				},
			},
			roads:{
				bridleway: "Bridleway",
				bus_guideway: "Bus guideway",
				busway: "Busway",
				construction : "Construction",
				crossing: "Crossing",
				cycleway: "Cycleway",
				footway: "Footway",
				living_street: "Living street",
				motorway: "Motorway",
				motorway_link: "Motorway link",
				path: "Path",
				pedestrian: "Pedestrian",
				primary: "Primary",
				primary_link: "primary link",
				proposed: "Proposed",
				raceway: "Raceway",
				residential: "Residential",
				road: "Road",
				secondary: "Secondary",
				secondary_link: "Secondary link",
				service: "Service",
				steps: "Steps",
				tertiary: "Tertiary",
				tertiary_link: "Tertiary link",
				track: "Track",
				trunk: "Trunk",
				trunk_link: "Trunk link",
				turning_circle: "Turning circle",
				unclassified: "Unclassified",
			},
		},
		temperature: {
			global: "Average temperature",
			average: "Average",
			help: "Select a column to view details",
		},
		trips: {
			columns: [
				{
					title: "Driver",
					visible: true,
				},
				{
					title: "Device",
					visible: true,
				},
				{
					title: "Start date",
					visible: true,
				},
				{
					title: "End date",
					visible: true,
				},
				{
					title: "Duration",
					visible: true,
				},
				{
					title: "Start coordinates",
					visible: true,
				},
				{
					title: "End coordinates",
					visible: true,
				},
				{
					title: "Start address",
					visible: true,
				},
				{
					title: "End address",
					visible: true,
				},
			],
			details: {
				columns: ["Initial data", "Final data"],
				rows: ["Date", "Coordinates", "Address"],
			},
		},
		notifications: {
			query: {
				nodata: "No data for the query",
				error: "Query failure",
				noparams:
					"You must select at least one device and the date range",
			},
			timezone: {
				info: "Dear GS Trackme users - With the time change following daylight savings. We are experiencing an one hour discrepancy if you run a report for dates prior to Nov 1st. We are actively working to adjust this. Thanks for your patience.",
			},
		},
		status_report: {
			labels: [
				"Devices report by status",
				"This report is actual information",
				"Reload information",
				"Filter by name, imei or phone",
				"No information",
				"Status",
				"Download excel file",
				"Status report",
			],
			table_head: [
				"Name",
				"Imei",
				"Phone",
				"Status",
				"Last location",
				"Last tracking",
			],
			table_pagination: ["Page", "of", "rows per page"],
			code_status: {
				0: "Canceled",
				1: "Active",
				3: "Inactive24",
				7: "Inactive72",
				20: "WithoutGps",
				21: "WithoutPush",
				22: "Sleep",
				23: "EngineStop",
				24: "WithoutBattery",
				25: "Suspended",
			},
		},
	},
};
